module.exports = __webpack_public_path__ + "img/gs.33cc3eba.svg";